(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-collection"]) return;
  try {
    
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bf-model-toggle]');
    if (!btn) return;
    var scope = btn.closest('[data-bf-coll]') || document;
    var grid = scope.querySelector('[data-bf-coll-grid]');
    if (!grid) return;
    var on = grid.classList.toggle('is-porte');
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var lbl = btn.querySelector('[data-bf-model-label]');
    if (lbl) lbl.textContent = on ? (btn.getAttribute('data-on') || '') : (btn.getAttribute('data-off') || '');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-countdown"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initCd(el) {
    if (el.dataset.bfCdReady) return;
    el.dataset.bfCdReady = '1';
    var target = new Date(el.getAttribute('data-target')).getTime();
    var timer = el.querySelector('[data-bf-cd-timer]');
    var done = el.querySelector('[data-bf-cd-done]');
    var expire = el.getAttribute('data-expire');
    if (isNaN(target)) { if (timer) timer.style.display = 'none'; return; }

    var units = [];
    if (timer) {
      [['days', 'l-days'], ['hours', 'l-hours'], ['minutes', 'l-minutes'], ['seconds', 'l-seconds']].forEach(function (u) {
        if (timer.getAttribute('data-show-' + u[0]) === '1') {
          var wrap = document.createElement('div'); wrap.className = 'bf-cd__u';
          var n = document.createElement('span'); n.className = 'bf-cd__n'; n.textContent = '00';
          var l = document.createElement('span'); l.className = 'bf-cd__l'; l.textContent = timer.getAttribute('data-' + u[1]) || '';
          wrap.appendChild(n); wrap.appendChild(l); timer.appendChild(wrap);
          units.push({ key: u[0], n: n });
        }
      });
    }

    function ended() {
      if (expire === 'message') { if (timer) timer.style.display = 'none'; if (done) done.hidden = false; }
      else { var host = el.closest('.bf-home') || el; host.style.display = 'none'; }
    }
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { units.forEach(function (u) { u.n.textContent = '00'; }); ended(); clearInterval(iv); return; }
      var sec = Math.floor(diff / 1000);
      var d = Math.floor(sec / 86400), h = Math.floor((sec % 86400) / 3600), m = Math.floor((sec % 3600) / 60), s = sec % 60;
      var acc = { days: d, hours: h, minutes: m, seconds: s };
      // If the days are hidden, we roll them back into the hours.
      if (!units.some(function (u) { return u.key === 'days'; })) acc.hours += d * 24;
      units.forEach(function (u) { u.n.textContent = pad(acc[u.key]); });
    }
    tick();
    var iv = setInterval(tick, 1000);

    if (el.classList.contains('bf-cd--anim')) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (e) { if (e.isIntersecting) { el.classList.add('is-in'); io.disconnect(); } });
        }, { threshold: .2 });
        io.observe(el);
      } else { el.classList.add('is-in'); }
    }
  }
  function boot(root) { (root || document).querySelectorAll('[data-bf-cd]').forEach(initCd); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-mobile-dock"] && !Shopify.designMode) return;
  try {
    
(function () {
  function fire(sel) { var t = document.querySelector(sel); if (t) t.click(); }
  function initDock(el) {
    if (el.dataset.bfDockReady) return;
    el.dataset.bfDockReady = '1';
    var m = el.querySelector('[data-bf-dock-menu]');
    if (m) m.addEventListener('click', function () { fire('[data-bf-drawer-open]'); });
    var s = el.querySelector('[data-bf-dock-search]');
    if (s) s.addEventListener('click', function () { fire('[data-bf-search-open]'); });
    // The cart uses data-bf-cart-open, already listened to by the theme across the whole document.
  }
  function boot(root) { (root || document).querySelectorAll('[data-bf-dock]').forEach(initDock); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-shop-feed"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFeed(el) {
    if (el.dataset.bfFeedReady) return;
    el.dataset.bfFeedReady = '1';
    var spots = el.querySelectorAll('.bf-feed__spot');
    function closeAll(ex) { spots.forEach(function (sp) { if (sp !== ex) { sp.classList.remove('is-open'); var b = sp.querySelector('[data-bf-feed-dot]'); if (b) b.setAttribute('aria-expanded', 'false'); } }); }
    spots.forEach(function (sp) {
      var dot = sp.querySelector('[data-bf-feed-dot]');
      if (!dot) return;
      dot.addEventListener('click', function (e) { e.stopPropagation(); var o = sp.classList.contains('is-open'); closeAll(sp); sp.classList.toggle('is-open', !o); dot.setAttribute('aria-expanded', String(!o)); });
    });
    document.addEventListener('click', function (e) { if (!el.contains(e.target)) closeAll(); });
    // Video on hover (if autoplay unchecked but video media present).
    el.querySelectorAll('.bf-feed__card').forEach(function (card) {
      var v = card.querySelector('video.bf-feed__video');
      if (!v || v.autoplay) return;
      card.addEventListener('mouseenter', function () { try { v.play(); } catch (e) {} });
      card.addEventListener('mouseleave', function () { try { v.pause(); } catch (e) {} });
    });
  }
  function boot(root) { (root || document).querySelectorAll('[data-bf-feed]').forEach(initFeed); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-shop-look"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSl(el) {
    if (el.dataset.bfSlReady) return;
    el.dataset.bfSlReady = '1';
    var spots = el.querySelectorAll('.bf-sl__spot');
    function closeAll(except) {
      spots.forEach(function (sp) { if (sp !== except) { sp.classList.remove('is-open'); var b = sp.querySelector('[data-bf-sl-dot]'); if (b) b.setAttribute('aria-expanded', 'false'); } });
    }
    spots.forEach(function (sp) {
      var dot = sp.querySelector('[data-bf-sl-dot]');
      if (!dot) return;
      dot.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = sp.classList.contains('is-open');
        closeAll(sp);
        sp.classList.toggle('is-open', !open);
        dot.setAttribute('aria-expanded', String(!open));
      });
    });
    document.addEventListener('click', function (e) { if (!el.contains(e.target)) closeAll(); });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }
  function boot(root) { (root || document).querySelectorAll('[data-bf-sl]').forEach(initSl); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-texte-defilant"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initMq(el) {
    if (el.dataset.bfMqReady) return;
    el.dataset.bfMqReady = '1';
    var track = el.querySelector('[data-bf-mq-track]');
    var group = el.querySelector('[data-bf-mq-group]');
    if (!track || !group) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var speed = parseFloat(el.getAttribute('data-speed')) || 60; // px/seconde

    function build() {
      // Removes the previous copies.
      track.querySelectorAll('[data-bf-mq-clone]').forEach(function (n) { n.remove(); });
      var viewport = el.querySelector('.bf-mq__viewport');
      var w = group.scrollWidth;
      if (!w || !viewport) return;
      var need = Math.ceil(viewport.offsetWidth / w) + 1;
      for (var i = 0; i < need; i++) {
        var c = group.cloneNode(true);
        c.setAttribute('data-bf-mq-clone', '1');
        c.removeAttribute('data-bf-mq-group');
        track.appendChild(c);
      }
      var total = group.scrollWidth; // width of one group (including padding-right)
      track.style.setProperty('--mq-shift', total + 'px');
      track.style.setProperty('--mq-dur', (total / speed) + 's');
      track.classList.add('is-anim');
      if (el.getAttribute('data-direction') === 'rtl') track.classList.add('is-rtl');
    }
    build();
    var ro; if ('ResizeObserver' in window) { ro = new ResizeObserver(build); ro.observe(el); }
    else window.addEventListener('resize', build);
  }
  function boot(root) { (root || document).querySelectorAll('[data-bf-mq]').forEach(initMq); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  function animateNum(el) {
    var to = parseFloat(el.getAttribute('data-to')) || 0;
    var pre = el.getAttribute('data-prefix') || '', suf = el.getAttribute('data-suffix') || '';
    var dur = 1200, start = null, dec = (to % 1 !== 0) ? 1 : 0;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var val = (to * (0.2 + 0.8 * (1 - Math.pow(1 - p, 3)))); // ease-out
      el.textContent = pre + val.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + suf;
      if (p < 1) requestAnimationFrame(step); else el.textContent = pre + to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + suf;
    }
    requestAnimationFrame(step);
  }
  function initTl(el) {
    if (el.dataset.bfTlReady) return;
    el.dataset.bfTlReady = '1';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = el.querySelectorAll('.bf-tl__item');
    var nums = el.querySelectorAll('[data-bf-tl-num]');
    if (!('IntersectionObserver' in window) || reduce) {
      items.forEach(function (i) { i.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          var n = e.target.querySelector('[data-bf-tl-num]');
          if (n && !n.dataset.done) { n.dataset.done = '1'; animateNum(n); }
          io.unobserve(e.target);
        }
      });
    }, { threshold: .25 });
    items.forEach(function (i) { io.observe(i); });
  }
  function boot(root) { (root || document).querySelectorAll('[data-bf-tl]').forEach(initTl); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
